const hamburgerButton = document.querySelector('#hamburgerButton')
const hambugerMenu = document.querySelector('#hambugerMenu')
const hambugerBars = document.querySelector('.hamBars')
const hambugerX = document.querySelector('.hamX')

hamburgerButton.addEventListener('click', () => {

    let x = hambugerMenu
        
    if(x.classList.contains('active')){
        x.classList.remove('active');
        hambugerBars.classList.add('active')
        hambugerX.classList.remove('active')
        document.querySelector('body').style.overflow = 'auto'
    }else{
        x.classList.add('active');
        hambugerBars.classList.remove('active')
        hambugerX.classList.add('active')
        document.querySelector('body').style.overflow = 'hidden'
    }
})